import { Icon, Panel } from "@/shared/ui";

/**
 * Строка выбора актива на экране пополнения.
 *
 * Монета — единственный растровый элемент экрана, и он есть только у USDT:
 * `deposit_assets` задаёт оператор в админке, и завтра там может оказаться BTC
 * или ETH. Поэтому картинка не обязательна — без неё рисуется кружок с
 * тикером, ровно как у робота без загруженного изображения.
 */
const COIN_IMAGES: Record<string, string> = {
  USDT: "/assets/usdt-coin.png",
};

interface CryptoAssetRowProps {
  asset: string;
  networks: string[];
  selected: boolean;
  onSelect: () => void;
}

export function CryptoAssetRow({ asset, networks, selected, onSelect }: CryptoAssetRowProps) {
  const image = COIN_IMAGES[asset];

  return (
    <Panel
      as="div"
      tone={selected ? "green" : "neutral"}
      radius="lg"
      className={[
        "press-row w-full",
        "transition-colors duration-[var(--motion-fast)] ease-standard",
      ].join(" ")}
    >
      <button
        type="button"
        aria-pressed={selected}
        data-haptic="select"
        onClick={onSelect}
        className="flex w-full items-center gap-3.5 p-3.5 text-left"
      >
        {image ? (
          <img src={image} alt="" aria-hidden="true" className="size-[53px] shrink-0 rounded-full" />
        ) : (
          <span className="flex size-[53px] shrink-0 items-center justify-center rounded-full border border-border-subtle bg-[image:var(--surface-round-icon)] text-label font-bold text-status-profit">
            {asset.slice(0, 4)}
          </span>
        )}

        <span className="flex min-w-0 flex-1 flex-col gap-1">
          <span className="truncate text-h3 font-bold text-text-bright">{asset}</span>
          <span className="truncate text-small font-normal text-text-secondary">
            {networks.join(" · ")}
          </span>
        </span>

        <Icon name="caretRight" size={16} className="shrink-0 text-text-tertiary" />
      </button>
    </Panel>
  );
}
